<template>
  <div
    :style="{ width: width }"
    @click="openDatePickerModel"
    class="date-picker-btn"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  emits: ["openModal"],
  props: {
    width: {
      type: String,
    },
    iconColor: {
      type: String,
      default: "#000000",
    },
  },
  data() {
    return {};
  },
  methods: {
    openDatePickerModel() {
      this.$emit("openModal");
    },
  },
};
</script>

<style>
/* .v-input__control {
  padding-left: 10px;
}
.v-field--variant-plain {
  --v-field-padding-top: 12px !important;
  --v-field-padding-bottom: 12px !important;
}
.v-input--density-default {
  --v-input-padding-top: 0px !important;
} */
/* .v-locale--is-rtl .v-date-picker-controls__month {
  flex-direction: row !important;
} */

.date-picker-btn {
  border-radius: 50px;
  box-shadow: 0px 0px 4px 0px #00000040;
  width: 100%;
  cursor: pointer;
}

.close-icon {
  position: absolute;
  left: 8px;
  top: 8px;
  cursor: pointer;
}

.mdi-calendar-end::before,
.mdi-calendar-start::before {
  color: v-bind(iconColor) !important;
}
</style>
